import { Pipe, PipeTransform, inject } from '@angular/core';
import { TableConstructUIService } from '../services/table-construct.service';
import { TableCellDefUIDirective } from '../directives/table-cell-def.directive';

@Pipe({
  name: 'getCell',
  pure: false,
})
export class TableGetCellPipe<DataType> implements PipeTransform {
  private tableService = inject<TableConstructUIService<DataType>>(TableConstructUIService);

  transform(columnName: string): TableCellDefUIDirective<DataType> | null {
    return this.tableService.getCell(columnName);
  }
}
